<router-outlet></router-outlet>
<div class="before">
    <div id="overlay"></div>
    <div class="splash">
        <div class="text-center">
            <img src="assets/img/logo_new_3.png" alt="logo" class="drop-shadow" style="width: 100%; max-width: 180px">
        </div>

        <div class="text-center">
            <br>
            <br>
            <br>
            <br>
            <div class="loader"></div>
            <br> Setting up, please wait...
        </div>
    </div>
</div>
